const codec = require('./browserStorageCodec')

const ADMIN_SESSION_KEY = '__ec_web_console_runtime_session_v2__'
const LEGACY_TOKEN_KEY = 'token'

function getDefaultStorage() {
  return typeof localStorage === 'undefined' ? null : localStorage
}

function getAdminToken(storage = getDefaultStorage()) {
  if (!storage) return ''
  const session = codec.readJson(storage, ADMIN_SESSION_KEY)
  if (session && session.accessToken) {
    return session.accessToken
  }

  const legacyToken = storage.getItem(LEGACY_TOKEN_KEY)
  if (legacyToken) {
    setAdminToken(legacyToken, storage)
    return legacyToken
  }
  return ''
}

function setAdminToken(token, storage = getDefaultStorage()) {
  if (!storage) return
  if (!token) {
    clearAdminToken(storage)
    return
  }
  codec.writeJson(storage, ADMIN_SESSION_KEY, {
    accessToken: token,
    authChannel: 'admin-console',
    sessionKind: 'backend-route-guard',
    issuedAt: Date.now()
  })
  storage.removeItem(LEGACY_TOKEN_KEY)
}

function clearAdminToken(storage = getDefaultStorage()) {
  if (!storage) return
  codec.remove(storage, ADMIN_SESSION_KEY)
  storage.removeItem(LEGACY_TOKEN_KEY)
}

module.exports = {
  ADMIN_SESSION_KEY,
  getAdminToken,
  setAdminToken,
  clearAdminToken
}
